/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Beta_TitleInputs */

const da_terms_beta_title = /** @type {(inputs: Terms_Beta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta`)
};

/** @type {(inputs: Terms_Beta_TitleInputs) => LocalizedString} */
const en_terms_beta_title = da_terms_beta_title;

/**

* @param {Terms_Beta_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_beta_title = /** @type {((inputs?: Terms_Beta_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Beta_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_beta_title(inputs)
	return /** @type {LocalizedString} */ ("Beta")
});